/* Announcement ticker.
 *
 * Two jobs: keep the loop seamless, and let people stop it.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* The marquee is N copies of the same list translating -50%. That only looks
   * continuous while ONE copy is at least as wide as the visible band: the
   * animation ends showing content from W to W+viewport, and the track only
   * holds 2W. With two short lines on a wide monitor the copy runs out and the
   * band goes empty before it snaps back.
   *
   * So: keep doubling the content until the track is at least twice the band.
   * Doubling — never adding an odd copy — is what preserves the -50% landing on
   * an identical frame.
   */
  function fill(root, track) {
    if (reduced.matches) return;

    var original = Array.prototype.slice.call(track.children);
    if (!original.length) return;

    // Re-doubling on every resize would grow the track forever; start over.
    while (track.children.length > original.length) {
      track.removeChild(track.lastChild);
    }

    var guard = 0;
    while (track.scrollWidth < root.clientWidth * 2 && guard < 6) {
      original.forEach(function (node) {
        var copy = node.cloneNode(true);
        // Every copy is decorative — the first one is the one screen readers get.
        copy.setAttribute('aria-hidden', 'true');
        track.appendChild(copy);
      });
      guard++;
    }
  }

  document.querySelectorAll('[data-ticker]').forEach(function (root) {
    var track = root.querySelector('[data-ticker-track]');
    var button = root.querySelector('[data-ticker-pause]');
    if (!track) return;

    fill(root, track);

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () { fill(root, track); }, 150);
    }, { passive: true });

    // Content that moves for more than a few seconds needs a way to stop it.
    // The button is off-screen until it is tabbed to; hover pauses for everyone
    // else (see globals.css).
    if (!button) return;
    button.addEventListener('click', function () {
      var paused = track.style.animationPlayState === 'paused';
      track.style.animationPlayState = paused ? 'running' : 'paused';
      button.setAttribute('aria-pressed', paused ? 'false' : 'true');
      button.textContent = paused ? 'Pause the ticker' : 'Start the ticker';
    });
  });
})();
